import { ToggleButtonGroup, ToggleButton, styled } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

const { body1 } = theme.typography;

export const StyledButtonGroup = styled(ToggleButtonGroup)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const StyledButton = styled(ToggleButton)`
  ${body1};
  flex-basis: 40%;
  text-transform: none;
`;
